import { useLocalSettings } from '@/hooks/useLocalSettings'

export type TabStyle = 'rounded' | 'boxes' | 'underline'

export const DEFAULT_TAB_STYLE: TabStyle = 'rounded'

export const useTabStyle = (): TabStyle => {
  const { getSetting } = useLocalSettings()
  return getSetting('tabStyle') ?? DEFAULT_TAB_STYLE
}
